import { useMemo } from "react";
import { Group } from "three";
import { applyToonMaterial } from "../utils";

export function useAssignCustomShaderMaterial(
  scene: Group,
  customMaterials?: string,
): Group {
  if (!customMaterials) {
    return scene;
  }
  const clonedScene = useMemo(() => {
    const clone = scene.clone(true);
    switch (customMaterials) {
      case "Toon Material":
        return applyToonMaterial(clone);
      default:
        return clone;
    }
  }, [scene, customMaterials]);

  return clonedScene;
}
